import { CDN2 } from '@/helpers/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'antd';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import { faCheck, faCopy } from '@fortawesome/free-solid-svg-icons';

export default function CouponContent({
  configInfo,
  id,
  airportName,
  ...props
}) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const codeToCopy = `${id}${configInfo.couponPageSuffix}`;
    const textArea = document.createElement('textarea');
    textArea.value = codeToCopy;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);

    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section
      id={`${id}-offers`}
      className="flex flex-col items-center p-4 mt-8 gap-8"
    >
      <div className="flex flex-col items-center text-center border border-gray-300 p-6 hover:border-primary transition h-auto w-full">
        <h2 className="text-xl lg:text-3xl font-bold uppercase mb-4">
          How to Save on {airportName} Parking
        </h2>
        <p className="text-lg text-center">
          Use the discount code below to save on your booking, whether through
          our <b className="text-primary"> app</b> or{' '}
          <b className="text-primary"> website</b>.
        </p>

        <Button
          className="flex items-center justify-between gap-4 max-w-sm w-full border border-dotted rounded-md my-4 border-primary"
          onClick={handleCopy}
        >
          {copied ? (
            <div className="flex w-full items-center">
              <span className="flex-1 text-center">
                Code copied to clipboard
              </span>
              <FontAwesomeIcon
                icon={faCheck}
                {...props}
                style={{ width: 20, height: 20 }}
                className="ml-auto"
              />
            </div>
          ) : (
            <div className="flex w-full items-center">
              <span className="flex-1 text-center text-primary font-bold">
                {id}
                {configInfo.couponPageSuffix}
              </span>
              <FontAwesomeIcon
                icon={faCopy}
                {...props}
                style={{ width: 20, height: 20 }}
                className="ml-auto text-primary"
              />
            </div>
          )}
        </Button>

        <ul className="text-lg text-center mt-4">
          <li>
            <b>Get ${configInfo.couponPageAppDiscount} off</b> when booking
            through our <b className="text-primary">app</b> —just enter the code
            at checkout .
          </li>
          <li className="mt-2">
            <b>Save ${configInfo.couponPageWebDiscount}</b> when booking on our
            <b className="text-primary"> website</b> —copy the code and apply it
            at checkout.
          </li>
        </ul>

        <p className="text-lg text-center mt-4">
          Make sure you're <b>logged in</b> to redeem your coupon!
        </p>
      </div>

      <Link
        passHref
        href={`/myreservation/getapp?redir=1`}
        className="text-center hover:underline"
      >
        <Image
          src={`${CDN2()}/staticmyapp/qrcodeDownloadAppRedir.png`}
          width={300}
          height={300}
          alt="Download App QR Code"
          className="mx-auto"
        />
        <p className="text-lg">
          Scan the QR code or <b>tap here</b> to download the app.
        </p>
      </Link>
    </section>
  );
}
